"use client";

import ImageWithListCard from "@/revamp/molecules/ImageWithListCard";
import Carousel from "@/components/molecules/CustomCarousels/Carousel";

export default function HolisticCareerServicesSection({ data, isSpecificPage=false }) {
  return (
    <div className="Carousel">
      <Carousel
        children={data.map((item, index) => (
          <ImageWithListCard {...item} key={index} isSpecificPage={isSpecificPage} />
        ))}
        className="!my-0"
        config={{
          autoplay: {
            delay: 6000,
          },
          spaceBetween: 20,
          slidesPerView: 1,
          pagination: {
            className: "program_detail_carousel_pagination text-center my-4",
          },
          breakpoints: {
            0: {
              slidesPerView: 1
            },
            481: {
              slidesPerView: 2,
              spaceBetween: 15
            },
            769: {
              slidesPerView: 3,
              spaceBetween: 20
            },
            1025: {
              slidesPerView: 4,
              spaceBetween: 30
            }
          }
        }}
      />

    </div>
  );
}
